<template>
  <el-dialog
    :title="id ? (this.type === 'copy' ? '复制产品' : '编辑产品') : '添加产品'"
    :visible.sync="dialogFormVisible"
    width="600px"
  >
    <el-form
      ref="dataForm"
      :rules="rules"
      :model="temp"
      label-position="left"
      label-width="100px"
      style="margin: 0 30px"
    >
      <template>
        <el-form-item label="产品名称" prop="name">
          <el-input v-model="temp.name" />
        </el-form-item>
        <el-form-item label="项目" prop="project_id">
          <el-select
            v-model="temp.project_id"
            filterable
            placeholder="请选择"
            style="width: 100%"
            :disabled="type === 'edit'"
          >
            <el-option
              v-for="item in project_options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="场次" prop="interval_time">
          <TimeSelect
            v-model="temp.interval_time"
            @changeInterval="(e) => (temp.interval_time = e)"
            :disabled="type === 'edit'"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="类型" prop="trip_type">
          <el-radio-group v-model="temp.trip_type">
            <el-radio :label="1">拼团</el-radio>
            <el-radio :label="2">包团</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="人数上限" prop="user_limit">
          <el-input v-model="temp.user_limit" />
        </el-form-item>
        <el-form-item label="结算价" prop="cost">
          <el-input type="number" v-model="temp.cost"
            ><template slot="prepend">¥</template></el-input
          >
        </el-form-item>
        <el-form-item label="导游结算价" prop="guide_service_price">
          <el-input type="number" v-model="temp.guide_service_price"
            ><template slot="prepend">¥</template></el-input
          >
        </el-form-item>
        <el-form-item label="同程票行ID" prop="tc_ticket_id">
          <el-input
            v-model="temp.tc_ticket_id"
            placeholder="请输入同程票行ID，用于直接购买门票"
            :disabled="type === 'edit'"
          />
        </el-form-item>
        <!-- <el-form-item label="城市" prop="city">
          <CitySelect
            customStyle="width: 100%"
            v-model="temp.city"
            @onChange="(e) => (temp.city = e)"
            :disabled="!!id"
          />
        </el-form-item> -->
        <el-form-item label="所属平台" prop="platform">
          <el-select v-model="temp.platform" filterable placeholder="请选择" style="width: 100%">
            <el-option
              v-for="item in platform_options"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </template>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取消</el-button>
      <el-button type="primary" @click="saveData">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getDetail, add, edit } from '@/api/products'
import { getList as getProjectList } from '@/api/projects'
import TimeSelect from '@/components/TimeSelect'
import { PLATFORM_OPTIONS } from '@/utils/platform'
const rule = [{ required: true, message: '必填项不能为空' }]
export default {
  name: 'ProductsEdit',
  components: {
    TimeSelect
  },
  data() {
    return {
      dialogFormVisible: false,
      id: '',
      temp: {
        name: '',
        project_id: '',
        interval_time: '',
        trip_type: '',
        user_limit: '',
        cost: 0,
        guide_service_price: null,
        tc_ticket_id: '',
        platform: ''
      },
      rules: {
        name: rule,
        project_id: rule,
        interval_time: rule,
        trip_type: rule,
        user_limit: rule,
        guide_service_price: rule,
        platform: rule
      },
      type: '',
      project_options: [],
      platform_options: PLATFORM_OPTIONS
    }
  },
  created() {
    getProjectList({ size: 1000 }).then((res) => {
      this.project_options = res.data.results
    })
  },
  methods: {
    // 添加
    handleCreate() {
      this.id = ''
      this.temp = {
        name: '',
        project_id: '',
        interval_time: '',
        trip_type: '',
        user_limit: '',
        cost: 0,
        guide_service_price: null,
        tc_ticket_id: '',
        platform: ''
      }
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs.dataForm.clearValidate()
      })
    },
    _getDetail(id) {
      getDetail(id).then((res) => {
        this.id = id
        Object.assign(this.temp, { ...res.data, project_id: res.data.project.id })
        this.dialogFormVisible = true
        this.$nextTick(() => {
          this.$refs.dataForm.clearValidate()
        })
      })
    },
    // 编辑
    handleEdit(id, type) {
      this.type = type
      this.temp = {
        name: '',
        project_id: '',
        interval_time: '',
        trip_type: '',
        user_limit: '',
        cost: 0,
        guide_service_price: null,
        tc_ticket_id: '',
        platform: ''
      }
      this._getDetail(id)
    },
    /**
     * @description: 复制
     * @return {*}
     */
    handleCopy(id, type) {
      this.type = type
      this._getDetail(id)
    },
    // 保存
    saveData() {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          const d = JSON.parse(JSON.stringify(this.temp))
          const p = this.type === 'edit' ? edit(this.id, d) : add(d)
          p.then(() => {
            this.$parent.fetchData()
            this.dialogFormVisible = false
            this.$parent.$notify({
              title: '成功',
              message: '操作成功',
              type: 'success'
            })
          })
        }
      })
    }
  }
}
</script>
